import { DynamicHoverData } from '~/entities/MyTickets/types/dynamicHover';
import { DefaultDetails } from '../FormSpecific/DefaultDetails';
import { CoiHover } from './CoiHover';
import { EmployeeMovementsHover } from './EmployeeMovementsHover';
import { GiftsAndDonationsHover } from './GiftsAndDonationsHover';
import { OtherComplianceMattersHover } from './OtherComplianceMattersHover';

interface DynamicHoverFactoryProps {
  dynamicData?: DynamicHoverData | null;
  employeeId: string;
  band: string;
  positionTitle: string;
  description: string;
}

export function DynamicHoverFactory({
  dynamicData,
  employeeId,
  band,
  positionTitle,
  description,
}: DynamicHoverFactoryProps) {
  if (!dynamicData) {
    return (
      <DefaultDetails
        employeeId={employeeId}
        band={band}
        positionTitle={positionTitle}
        description={description}
      />
    );
  }

  const formTypeCategory = `${dynamicData.formType}-${dynamicData.category}`;

  switch (formTypeCategory) {
    case 'giftsAndDonations-youAreGiving':
    case 'giftsAndDonations-youAreReceiving':
    case 'giftsAndDonations-officeInternalUsage':
      return (<GiftsAndDonationsHover dynamicData={dynamicData} />);

    case 'otherComplianceMatters-benchmarking':
    case 'otherComplianceMatters-questionsOnPoliciesCodeOfBusinessConduct':
      return (<OtherComplianceMattersHover dynamicData={dynamicData} />);

    case 'conflictOfInterest-relationships':
    case 'conflictOfInterest-otherOccupation':
    case 'conflictOfInterest-personalInvestment':
      return (<CoiHover dynamicData={dynamicData} />);

    case 'employeeMovement-internalMovement':
    case 'employeeMovement-rehiring':
    case 'employeeMovement-referrals':
      return (<EmployeeMovementsHover dynamicData={dynamicData} />);

    default:
      return (
        <DefaultDetails
          employeeId={employeeId}
          band={band}
          positionTitle={positionTitle}
          description={description}
        />
      );
  }
}